export function UpsertAssumptionRecord(scenarioID: string, mode: string, values?: any,): any {
    const formatPercentage = (value: any): string => {
        return ((value ?? 0) / 100).toFixed(2).toString();
    };

    if (mode === "editing") {
        return {
            // editing assumption record
            inScenarioID: scenarioID,
            inProjectTypeID: values.ProjectTypeID,
            inTimePlanning: formatPercentage(values.PlanningTimePercentage),
            inTimeConstruction: formatPercentage(values.ConstructionTimePercentage),
            inTimeCommissioning: formatPercentage(values.CommissioningTimePercentage),
            inInvestmentPlanning: formatPercentage(values.PlanningCostPercentage),
            inInvestmentConstruction: formatPercentage(values.ConstructionCostPercentage),
            inInvestmentCommissioning: formatPercentage(values.CommissioningCostPercentage)
        };
    } else if (mode === "deleting") {
        return {
            // deleting assumption record
            inScenarioID: scenarioID,
            inProjectTypeID: values.ProjectTypeID,
        };
    } else {
        return {
            // creating assumption record
            inScenarioID: scenarioID,
            inProjectTypeID: values.ProjectTypeID,
            inTimePlanning: formatPercentage(values.PlanningTimePercentage),
            inTimeConstruction: formatPercentage(values.ConstructionTimePercentage),
            inTimeCommissioning: formatPercentage(values.CommissioningTimePercentage),
            inInvestmentPlanning: formatPercentage(values.PlanningCostPercentage),
            inInvestmentConstruction: formatPercentage(values.ConstructionCostPercentage),
            inInvestmentCommissioning: formatPercentage(values.CommissioningCostPercentage)
        };
    }
}
